import { render } from "./AdminEdit.vue?vue&type=template&id=45ab939f&scoped=true"
import script from "./AdminEdit.vue?vue&type=script&lang=js"
export * from "./AdminEdit.vue?vue&type=script&lang=js"

import "./AdminEdit.css?vue&type=style&index=0&id=45ab939f&scoped=true&lang=css&external"
import "./AdminEdit.vue?vue&type=style&index=1&id=45ab939f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ab939f"]])

export default __exports__